import { AuditLogSourceEnum } from 'src/graphql/schema';
import { Badge } from '@/components/ui/badge';

import { type IAuditLogNode, type IPayload } from '../model';

type Props = {
  source: IAuditLogNode['source'];
  payload: IAuditLogNode['payload'];
  user: IAuditLogNode['user'];
  eventType: string;
};

const AuditLogsByCell = ({ source, payload, user, eventType }: Props) => {
  if (eventType === 'escrow_invitation_rejected') return payload?.invited_name;

  if (source === AuditLogSourceEnum.Codekeeper) return <Badge className="font-normal">Codekeeper</Badge>;

  if (source === AuditLogSourceEnum.System)
    return (
      <Badge variant="outline" className="font-normal">
        System
      </Badge>
    );

  if (source === AuditLogSourceEnum.Counterparty) {
    const name = (payload as IPayload)?.counterparty_name;
    return name ? name : null;
  }

  if (source === AuditLogSourceEnum.User) return user?.name ? user.name : null;

  return null;
};

export default AuditLogsByCell;
